import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';

interface HolidaysModels {
  id: string;
  holidayName: string;
  holidayName2: string;
  holidayDateFrom: string;
  holidayDateTo: string;
  rotationPlanId: string;
  description: string;

 
  rotationPlanName: string;
  rotationPlanName2: string;
 }

export const addHolidays = createAsyncThunk(
  'Holidays/addHolidays',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('RAQ/AddHolidays', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateHolidays = createAsyncThunk(
  'Holidays/updateHolidays',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('RAQ/UpdateHolidays', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getHolidaysList = createAsyncThunk(
  'Holidays/getHolidaysList',
  async ({ id }: { id?: string }, { rejectWithValue }) => {
    try {
      const params = id ? { rotationPlanId: id } : {};
      const { data } = await ntxAPI.get(`RAQ/GetHolidaysList`, { params });
      if (data.succeeded === true) {
        return data.data;
      } else {
        return [];
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getHolidaysById = createAsyncThunk(
  'Holidays/getHolidaysById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`RAQ/GetHolidaysById?id=${id}`);
      if (data.succeeded === true) {
        return data.data;
      } else {
        return [];
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  HolidaysList: HolidaysModels[];
  loading: boolean;
  error: any | null;
  //~~~~~~~~~
  HolidayById: HolidaysModels;
  loadingById: boolean;
  errorById: any | null;
} = {
  HolidaysList: [],
  loading: false,
  error: null,
  HolidayById: {} as HolidaysModels,
  loadingById: false,
  errorById: null,
};

const HolidaysSlice = createSlice({
  name: 'Holidays',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getHolidaysList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getHolidaysList.fulfilled, (state, action: PayloadAction<HolidaysModels[]>) => {
        state.loading = false;
        state.HolidaysList = action.payload;
      })
      .addCase(getHolidaysList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      .addCase(getHolidaysById.pending, (state, action) => {
        state.loadingById = true;
        state.errorById = null;
      })
      .addCase(getHolidaysById.fulfilled, (state, action: PayloadAction<HolidaysModels>) => {
        state.loadingById = false;
        state.HolidayById = action.payload;
      })
      .addCase(getHolidaysById.rejected, (state, action: PayloadAction<any>) => {
        state.loadingById = false;
        state.errorById = action.payload;
      });
  },
});

export default HolidaysSlice.reducer;
